export default __webpack_public_path__ + "static/media/12-6-97-maze.89bfa253.m4a";